import { AdminBootstrapResponse, AppSettings, PublicBootstrapResponse, PublicTableResponse, TableRecord } from './types';

async function request<T>(url: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(url, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = typeof data?.error?.message === 'string' ? data.error.message : '요청 처리 중 오류가 발생했습니다.';
    throw new Error(message);
  }

  return data as T;
}

export const ADMIN_TOKEN_KEY = 'gongindae-bar-admin-token';

export function formatPhoneInput(value: string) {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}

export const api = {
  getPublicBootstrap: () => request<PublicBootstrapResponse>('/api/public/bootstrap'),
  createTable: (payload: { tableNumber: string; name: string; phone: string; partySize: number }) =>
    request<{ table: TableRecord }>('/api/public/tables', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
  getPublicTable: (tableId: string) =>
    request<PublicTableResponse>(`/api/public/tables/${tableId}`),
  adminLogin: (password: string) =>
    request<{ token: string }>('/api/admin/login', {
      method: 'POST',
      body: JSON.stringify({ password }),
    }),
  getAdminBootstrap: (token: string) =>
    request<AdminBootstrapResponse>('/api/admin/bootstrap', {
      headers: { Authorization: `Bearer ${token}` },
    }),
  patchAdminSettings: (token: string, payload: Partial<AppSettings>) =>
    request<{ settings: AppSettings }>('/api/admin/settings', {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    }),
  patchAdminTable: (
    token: string,
    tableId: string,
    payload: Partial<Pick<TableRecord, 'tableNumber' | 'name' | 'phone' | 'partySize'>> & { minutesDelta?: number },
  ) =>
    request<{ table: TableRecord }>(`/api/admin/tables/${tableId}`, {
      method: 'PATCH',
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    }),
  deleteAdminTable: (token: string, tableId: string) =>
    request<{ success: boolean }>(`/api/admin/tables/${tableId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    }),
};
